// token 相关接口

import Cookies from "js-cookie";
import Config from "@/settings";
import { useRoute } from "vue-router";
import { alertBox } from "@/utils/msgBox";
import useAccountStore from "@/store/modules/account";
const route = useRoute();
const tokenKey = Config.tokenKey;
let logoutTime = null
/**
 * 获取token
 * @returns
 */
export function getToken() {
  return Cookies.get(tokenKey);
}

/**
 * 设置token
 * @param {*} token 设置的token
 * @param {*} expiresTime 过期时间，单位秒，默认 30分钟
 * @returns
 */
export function setToken(token, expiresTime = 30 * 60) {
  const expires = new Date(new Date() * 1 + expiresTime * 1000);
  goBack()
  logoutTime = setTimeout(() => {
    alertBox("长时间无操作，请重新登录", "确定", "warning").finally(
      () => {            
        useAccountStore()
          .logOut(true)
          .then(() => {
            location.href = "/";
          });
      }
    );
  },expiresTime * 1000)
  return Cookies.set(tokenKey, token, { expires: expires });
}

export function updateTokenExpiresTime() {
  const tolen = getToken();
  setToken(tolen);
}
function goBack () {
  clearTimeout(logoutTime)
}
/**
 * 移除token
 * @returns
 */
export function removeToken() {
  return Cookies.remove(tokenKey);
}
